export const addressFormIreland = {
  postcode: { label: 'Eircode' },
}
